export const studentPasswords = [
  'patata',
  'gato',
  'azul',
  'rojo',
  'verde',
  'pera',
  'manzana',
  'pez',
  'rana',
  'sol',
  'luna',
  'nube',
  'dos',
  'tres',
  'uno',
  'mango',
  'uva',
  'galleta',
  'pastel',
  'tren',
  'bici',
  'kiwi',
  'oso',
  'puma',
  'pulpo',
  'mora',
  'fresa',
  'coco',
  'lima',
  'cinco',
];

export const teacherPasswordRules = {
  min: 8,
  max: 45,
};
